import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { LogConfig } from './log-service.types';

export function provideLogService(config: LogConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: 'LogConfig', useValue: config }
  ]);
}
